/**
 * Platform checks used to decide how a Google token may be renewed.
 *
 * Renewing a token always opens a Google pop-up. Desktop browsers let that
 * happen silently when a session is already signed in, but iPadOS only offers
 * "block always" or "ask each time" — and when it asks, the window opens after
 * the tap that triggered it has expired, so Google's handshake never completes
 * and the tab hangs. Touch Safari therefore has to ask the user to tap instead.
 */

/**
 * True on iPad/iPhone Safari.
 *
 * iPadOS 13+ reports itself as `MacIntel`, so the user-agent test alone misses
 * modern iPads; the touch-point count is what separates them from a real Mac.
 */
export const isTouchSafari = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    return true;
  }

  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
};
